<template>
  <div>
    <!-- 是否分享弹窗 -->
    <el-dialog
      class="share-dialog"
      width="350px"
      top="30vh"
      title="温馨提示"
      :visible.sync="show"
      append-to-body
      :close-on-click-modal="false"
      :before-close="close"
    >
      <div class="title">请选择是否分享</div>
      <div>
        <div class="radio">
          <el-radio v-model="shareRadio" label="1">分享给申请人</el-radio>
        </div>
        <div class="radio">
          <el-radio v-model="shareRadio" label="2">不分享</el-radio>
          <el-input v-model="share" placeholder="请输入原因"></el-input>
        </div>
      </div>
      <div class="btn">
        <el-button @click="close()">取消</el-button>
        <el-button class="sumbit" @click="shareSumbit()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 提示人脸 -->
    <Dialog
      :show="showFace"
      @dialogClose="showFace=false"
      :title="'温馨提示'"
      :content="'将信息采集的全部信息分享给申请人进行人脸识别校验'"
      :btn="'分享'"
      :btn2="'取消'"
    />
    <!-- 补贴信息 -->
    <el-dialog
      width="550px"
      class="info"
      title="申请补贴相关信息："
      :visible.sync="infoShow"
      append-to-body
      :close-on-click-modal="false"
      center
    >
      <div class="shareImg" ref="shareImg" v-if="info">
        <el-form :model="info">
          <el-form-item label="申请人姓名">{{info.applyRealName}}</el-form-item>
          <el-form-item label="申请人身份证号">{{info.applyIdCardNumber}}</el-form-item>
          <el-form-item label="申请人联系电话">{{info.applyPhoneNumber}}</el-form-item>
          <el-form-item label="申请人家庭住址">{{info.applyAddress}}</el-form-item>
          <el-form-item label="银行账户">{{info.applyBankAccountNumber}}</el-form-item>
          <el-form-item label="开户银行">{{info.applyBankName}}</el-form-item>
        </el-form>
        <el-table :data="info.tableData" border>
          <el-table-column header-align="center" align="center" label="补贴项目" prop="subsidyProject"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="补贴金额（元）"
            prop="subsidyAmount"
          ></el-table-column>
        </el-table>
        <vue-qr :text="QRcode" :size="200"></vue-qr>
      </div>
      <div class="btn">
        <el-button @click="saveImg()">保存图片到本地</el-button>
        <el-button class="sumbit" @click="shareFace">完成人脸校验</el-button>
      </div>
    </el-dialog>
    <!-- 分享成功 -->
    <Dialog
      :show="showEnd"
      @dialogClose="showEnd=false"
      :title="'温馨提示'"
      :content="'申请人人脸识别已校验成功，请继续操作'"
      :btn="'确认'"
      :btn2="'取消'"
    />
  </div>
</template>
<script>
import Dialog from "@/components/Dialog";
import VueQr from "vue-qr";
import { sessionStore } from "@/utils/data-management";
import html2canvas from "html2canvas";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Dialog,
    VueQr
  },
  data() {
    return {
      shareRadio: "1",
      share: "",
      showFace: false,
      infoShow: false,
      info: {},
      timeoutKey: "",
      QRcode: "",
      showEnd: false
    };
  },
  methods: {
    // 是否分享弹窗
    shareSumbit() {
      // 1-分享 2-不分享
      if (this.shareRadio == 1) {
        this.close();
        this.showFace = true;
        // this.getQRCode();
      } else {
        if (!this.share) {
          return this.$message.error("请输入不分享原因");
        }
        this.subsidyApply();
      }
    },
    // 关闭是否分享弹窗
    close() {
      this.$emit("dialogClose");
    },
    // 开启是否分享弹窗
    open() {
      this.$emit("dialogOpen");
    },
    // 分享人脸
    dialogSumbitL() {
      if (this.showFace) {
        this.showFace = false;
        this.getQRCode();
      } else {
        this.showEnd = false;
        this.$router.push("mySubsidy");
      }
    },
    dialogSumbitR() {
      if (this.showFace) {
        this.showFace = false;
        this.open();
      } else {
        this.showEnd = false;
        this.$router.push("mySubsidy");
      }
    },
    // 信息加载
    getQRCode() {
      const loading = this.$loading({
        lock: true,
        text: "申请补贴相关信息加载中",
        // spinner: 'el-icon-loading',
        background: "rgba(0, 0, 0, .05)"
      });
      this.info = sessionStore.get("subsidyInfo")
      this.$api.user
        .checkQRCodeValid({})
        .then(res => {
          loading.close();
          if (res.code === 1000) {
            this.timeoutKey = res.data.callbackId;
            this.QRcode = res.data.verifyFaceUrl;
            this.infoShow = true;
          }
        })
        .catch(err => {
          loading.close();
          this.$message.error("二维码获取失败,请稍后重试");
        });
    },
    // 下载图片
    saveImg() {
      setTimeout(() => {
        window.pageYOffset = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        html2canvas(this.$refs.shareImg).then(canvas => {
          // let dataUrl = canvas.toDataURL('image/png')
          let link = document.createElement("a");
          link.href = canvas.toDataURL();
          link.setAttribute("download", "申请补贴相关信息.png");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
        });
      }, 500);
    },
    // 轮询人脸校验
    shareFace() {
      let data = {
        callbackId: this.timeoutKey
      };
      this.$api.user.checkQRCode(data).then(res => {
        if (res.data.status == 1) {
          this.$message.success("FaceId验证成功");
          this.infoShow = false;
          setTimeout(() => {
            this.subsidyApply();
          }, 500);
        } else if (res.data.status == 0) {
          setTimeout(() => {
            this.shareFace();
          }, 5000);
        } else {
          this.$message.error("FaceId验证失败");
          this.infoShow = false;
        }
      });
    },
    // 代人补贴提交
    subsidyApply() {
      this.$api.apply.subsidySubmit({areaId: this.$store.state.cityArea.areaConfigId}).then(res => {
        if (res.code == 1000) {
          this.close();
          this.$message.success("申请补贴成功");
          this.infoShow = false;
          this.showEnd = true;
          setTimeout(() => {
            this.$router.push("mySubsidy");
          }, 500);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.share-dialog {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #ebecef;
  }
  /deep/ .el-dialog__body {
    padding-top: 12px;
    .title {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #394259;
      text-align: center;
      margin-bottom: 17px;
    }
    .radio {
      margin: 18px auto 0;
    }
    .el-input {
      width: 182px;
      input {
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(240, 240, 240, 1);
        padding: 9px 10px;
      }
    }
    .btn {
      margin: 36px auto 2px;
      justify-content: center;
    }
  }
}
.info {
  /deep/ .el-dialog__body {
    padding: 5px 0;
    .shareImg {
      padding: 20px 100px;
      text-align: center;
    }
    .el-form {
      margin-bottom: 25px;
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label,
        .el-form-item__content {
          line-height: 30px;
        }
      }
    }
    .el-table td,
    .el-table th {
      padding: 4px 0;
    }
    .btn {
      margin: 36px auto 20px;
      justify-content: center;
    }
  }
}
</style>